<template>
  <a-layout class="individual-layout">
    <IndividualInfoHeader/>
    <IndividualInfoTitle/>
    <IndividualScheduleList @responseStatus="getResponseMsg"/>
    <ModalApiResultMsg :visible="responseMsgObj.visible" :title="responseMsgObj.title"
      :okText="responseMsgObj.okText" :cancelText="responseMsgObj.cancelText" :msgClass="responseMsgObj.msgClass"
      :okCallback="responseMsgObj.msgClass === 'msg_error_modal' ? callPhoneNumber : hideModal"
      :cancelCallback="hideModal">
      <p>{{ responseMsgObj.detailText }}</p>
    </ModalApiResultMsg>
  </a-layout>
</template>

<script>
import IndividualInfoHeader from "../../components/individualInfo/IndividualInfoHeader.vue";
import IndividualInfoTitle from "../../components/individualInfo/IndividualInfoTitle.vue";
import IndividualScheduleList from "../../components/individualInfo/IndividualScheduleList.vue";
import ModalApiResultMsg from "../../components/modal/ModalApiResultMsg.vue";
import { mixinModalMethods } from "../../utils/mixins";
// import { mapActions } from 'vuex';

export default {
  name: 'IndividualScheduleListContainer',
  data() {
    return {
      // loaded: false,
    };
  },
  // async beforeMount() {
  //   localStorage.clear();
  //   this.verifyIdentity();
  // },
  components: {
    IndividualInfoHeader,
    IndividualInfoTitle,
    IndividualScheduleList,
    ModalApiResultMsg,
  },
  mixins: [mixinModalMethods],
  /* methods: {
    ...mapActions('identidyOpenStatus', ['deviceUidAction', 'openStatusAction']),
    ...mapActions('identidyInfo', ['identidyInfoAction']),
    async saveDeviceUid() {
      try {
        this.deviceUid = this.$route.query.data || '';
        this.deviceUidAction(this.deviceUid);
      } catch (error) {
        console.log(error);
      }
    },
    async verifyIdentity() {
      try {
        // this.isLoading = true;
        await this.saveDeviceUid();
        const params = {
          deviceUid: this.deviceUid,
        };
        const res = await this.openStatusAction(params);
        const { openedUser, carNo, openedMobile } = res;
        console.log(res)
        await this.identidyInfoAction({
          name: openedUser,
          carNo: carNo,
          phone: openedMobile,
        });
        this.loaded = true;
        // console.log(this.loaded)
      } catch (error) {
        console.log('openStatus', error);
        // this.isLoading = false;
        // this.visible = true;
      }
    },
  },   */
}
</script>
